import { computed } from 'vue'
import { usePage } from '@inertiajs/vue3'

export function useAppPage() {
    const page = usePage();

    const props = computed(() => page.props);

    // AUTH
    const user = computed(() => props.value.auth?.user ?? null);
    const personas = computed(() => props.value.auth?.user?.personas ?? []);
    const eauthToken = computed(() => props.value.auth?.eauth_token ?? null);

    // NOTIFICAÇÕES
    const notificacoesNaoLidasCount = computed(() => props.value.notificacoes_nao_lidas ?? 0);

    // ITENS DE MENU DESTAQUE VISÍVEIS
    const menusAreasVisiveis = computed(() => {
        if (props.value.menus_visiveis?.configurado) return props.value.menus_visiveis;

        return {
            menu_area_contribuinte: false,
            menu_area_fornecedor: false,
            menu_area_motorista: false,
            menu_area_servidor: false,
            menu_area_certidoes: false,
            menu_consulta_debitos: false,
        };
    });

    // INFORMATIVOS DOS MENUS
    const informativosMenus = computed(() => props.value.informativos_menus ?? {});

    // PERMITE MENSAGENS PROTOCOLO
    const permiteMensagensProtocolo = computed(() => props.value.permite_mensagens_processo ?? false);

    // FLASH MESSAGES
    const flash = computed(() => props.value.flash ?? {});

    const error = computed(() => flash.value.error ?? null);
    const warning = computed(() => flash.value.warning ?? null);
    const success = computed(() => flash.value.success ?? null);

    return {
        page,
        props,
        user,
        personas,
        eauthToken,
        notificacoesNaoLidasCount,
        menusAreasVisiveis,
        informativosMenus,
        permiteMensagensProtocolo,
        flash,
        error,
        warning,
        success
    }
}
